(function () {
    'use strict';
    angular.module('app').controller('LinkToExistingShipmentModalController', LinkToExistingShipmentModalController);
    LinkToExistingShipmentModalController.$inject = [
        '$uibModalInstance',
        'LinkShipmentsTableService',
        'LinkCompanyTableService',
        'AccountingService',
        'data',
        'toastr'
    ];

    function LinkToExistingShipmentModalController(
        $uibModalInstance,
        LinkShipmentsTableService,
        LinkCompanyTableService,
        AccountingService,
        data,
        toastr
    ) {
        const vm = this;
        vm.list = true;
        vm.data = data;
        vm.onCancelButtonClicked = onCancelButtonClicked;
        vm.onAddButtonClicked = onAddButtonClicked;

        init();
        function init() {
            vm.LinkShipmentTable = new LinkShipmentsTableService(vm.data).tableData
            vm.linkCompanyTable = new LinkCompanyTableService().tableData
        }

        function onCancelButtonClicked() {
            $uibModalInstance.dismiss();
        }

        function getSelected() {
            const selectedData = [];

            if (vm.list) {
                vm.LinkShipmentTable.data.forEach(shipment => {
                    if (shipment.isSelected) {
                        selectedData.push(shipment);
                    }
                });
            } else {
                vm.linkCompanyTable.data.forEach(company => {
                    if (company.isSelected) {

                        selectedData.push(company);
                    }
                });
            }


            return selectedData
        }

        function onAddButtonClicked() {
            const selectedData = getSelected();
            if (selectedData.length > 1 || !selectedData.length) {
                toastr.warning(`Select 1 Shipment to link.`);
                return;
            }

            tagFutileShipment(selectedData[0].consignmentId)
        }

        function tagFutileShipment(id) {
            const futileShipmentPayload = {
                linkToEntityType: vm.list ? 'link_to_shipment' : 'link_to_company',
                linkedEntityId: id,
                marginValue: vm.marginValue,
                marginPercent: vm.marginPercentage
            }
            AccountingService.Invoices.tagFutileShipment(
                vm.data,
                res => {
                    toastr.success('Successfully connected!');
                    $uibModalInstance.dismiss();
                },
                err => {
                    toastr.error(err.message)
                }, futileShipmentPayload
            )
        }
    }
})();



// WEBPACK FOOTER //
// ./js/controllers/accounting/modals/linkToExistingShipmentModalController.js